import "./index.scss"
import Sloth from "../../components/Sloth";


@Sloth.component({
    defaultOptions : {
        stars: 0
    }
})

export default class BaiKe {
    onInit() {

    }
}



/** WEBPACK FOOTER **
 ** ./src/BaiKe/index.js
 **/